export function clamp(t,[a,n]){return Math.min(n,Math.max(a,t))}
//# sourceMappingURL=index.module.js.map
